/* ============================================================================
   MODO SAP — el pedido con el aspecto de la pantalla de SAP Business One
   ---------------------------------------------------------------------------
   No es una pantalla aparte: es OTRA VISTA de `npLineas`, el mismo carrito de
   Nuevo pedido. Se entra y se sale sin perder nada, y al confirmar sigue el
   camino de siempre.

   POR QUE EXISTE
   Quien lleva años metiendo pedidos en SAP tiene el gesto aprendido: tabular
   de celda en celda, pegar una columna entera desde Excel, arrastrar para
   repetir un valor. Eso en una pantalla de tarjetas no se puede, y obliga a
   desaprender. Aqui no hay que desaprender nada.

   LO QUE SE PUEDE HACER
     · Escribir y tabular, como en SAP.
     · PEGAR desde Excel: varias filas y varias columnas de una vez.
     · ARRASTRAR el cuadradito de una celda para repetir el valor hacia abajo.
     · Pegar una lista de referencias y que el portal rellene el resto.

   SOLO SE MUESTRAN las columnas de las que hay dato de verdad. Una columna
   vacia en todas las filas estorba mas que ayuda.
============================================================================ */

var SAP_ON = false;
var SAP_SEL = null;      // {f, c} la celda activa
var SAP_INFO = {};       // itemcode -> datos del inventario

/* Las columnas, en el orden de SAP. `edit` dice si se escribe en ella;
   `calc` la deriva de las demas. */
var SAP_COLS = [
  {k:'n',      t:'#',                  w:30,  al:'center', ro:true},
  {k:'itemcode', t:'No. de artículo',  w:120, edit:true},
  {k:'itemname', t:'Descripción',      w:260, ro:true},
  {k:'barcode',  t:'Código de barras', w:120, ro:true, ocultable:true},
  {k:'quantity', t:'Cantidad',         w:70,  al:'right', edit:true, num:true},
  {k:'bultos',   t:'Bultos',           w:60,  al:'right', edit:true, num:true},
  {k:'price',    t:'Precio unitario',  w:85,  al:'right', edit:true, num:true, mon:true},
  {k:'discount', t:'% Desc.',          w:60,  al:'right', edit:true, num:true},
  {k:'neto',     t:'Precio neto',      w:85,  al:'right', ro:true, mon:true, calc:true},
  {k:'total',    t:'Total',            w:95,  al:'right', ro:true, mon:true, calc:true},
  {k:'stock',    t:'En stock',         w:70,  al:'right', ro:true, ocultable:true},
  {k:'comp',     t:'Comprometido',     w:85,  al:'right', ro:true, ocultable:true},
  {k:'disp',     t:'Disponible',       w:75,  al:'right', ro:true, ocultable:true},
  {k:'peso',     t:'Peso (kg)',        w:70,  al:'right', ro:true, ocultable:true},
  {k:'vol',      t:'Volumen (ft³)',    w:80,  al:'right', ro:true, ocultable:true}
];

function sapNum(v){ var n = parseFloat(String(v).replace(/[^0-9.\-]/g,'')); return isFinite(n)?n:0; }
function sapMon(v){
  return (Number(v)||0).toLocaleString('en-US',
    {minimumFractionDigits:2, maximumFractionDigits:2});
}
function sapEsc(s){
  return String(s==null?'':s).replace(/[&<>"]/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];
  });
}

// El valor de una celda, calculando las derivadas.
function sapVal(l, k, i){
  var cant = Number(l.quantity)||0;
  var pre  = Number(l.price)||0;
  var des  = Number(l.discount)||0;
  var b    = Math.max(1, Number(l.bulto)||1);
  var inf  = SAP_INFO[l.itemcode] || {};
  switch(k){
    case 'n':        return i+1;
    case 'itemcode': return l.itemcode || '';
    case 'itemname': return l.itemname || '';
    case 'barcode':  return inf.codebars || '';
    case 'quantity': return cant;
    case 'bultos':   return b>1 ? (Math.round(cant/b*100)/100) : '';
    case 'price':    return pre;
    case 'discount': return des;
    case 'neto':     return pre * (1 - des/100);
    case 'total':    return cant * pre * (1 - des/100);
    case 'stock':    return inf.onhand != null ? inf.onhand : '';
    case 'comp':     return inf.comprometido != null ? inf.comprometido : '';
    case 'disp':     return inf.disponible != null ? inf.disponible : '';
    case 'peso':     return inf.peso ? (Math.round(inf.peso*cant*100)/100) : '';
    case 'vol':      return inf.volumen ? (Math.round(inf.volumen*cant*10000)/10000) : '';
  }
  return '';
}

// Las columnas que de verdad tienen dato. Una columna vacia en todas las
// filas ocupa sitio y no dice nada.
function sapColsVisibles(){
  return SAP_COLS.filter(function(c){
    if(!c.ocultable) return true;
    return (npLineas||[]).some(function(l, i){
      var v = sapVal(l, c.k, i);
      return v !== '' && v != null;
    });
  });
}

// ── Pintar ──────────────────────────────────────────────────────────────────
function sapRender(){
  var box = document.getElementById('sap-grid');
  if(!box) return;
  var cols = sapColsVisibles();

  var h = '<table class="sapg"><thead><tr><th class="sel"></th>';
  cols.forEach(function(c){
    h += '<th style="width:'+c.w+'px'+(c.al==='right'?';text-align:right':'')
       + '">' + sapEsc(c.t) + '</th>';
  });
  h += '</tr></thead><tbody>';

  (npLineas||[]).forEach(function(l, i){
    h += '<tr data-f="'+i+'"><td class="sel" onclick="sapQuitar('+i+')" '
       + 'title="Quitar la línea">\u25b6</td>';
    cols.forEach(function(c, ci){
      var v = sapVal(l, c.k, i);
      var txt = (c.mon && v !== '') ? sapMon(v) : v;
      var cls = 'cel' + (c.ro?' ro':'') + (c.al==='right'?' der':'');
      h += '<td class="'+cls+'" data-f="'+i+'" data-c="'+c.k+'" '
         + (c.ro ? '' : 'tabindex="0" ')
         + 'onmousedown="sapClic(event,'+i+',\''+c.k+'\')" '
         + 'ondblclick="sapClic(event,'+i+',\''+c.k+'\')">'
         + '<span class="v">' + sapEsc(txt) + '</span>'
         + (c.ro ? '' : '<span class="tirador" onmousedown="sapArrastrar(event,'
             + i + ',\'' + c.k + '\')"></span>')
         + '</td>';
    });
    h += '</tr>';
  });

  // Una fila vacia al final: es donde se pega desde Excel y donde se escribe
  // la siguiente referencia sin tener que pulsar "agregar".
  h += '<tr class="nueva"><td class="sel">\u2736</td>';
  cols.forEach(function(c, ci){
    // En la fila nueva solo tiene sentido empezar por la referencia: hasta
    // que no hay articulo no hay precio ni bulto que poner. Al escribirla se
    // crea la linea y el cursor sigue a la siguiente columna.
    var abre = (c.k === 'itemcode');
    h += '<td class="cel' + (c.ro?' ro':'') + (c.al==='right'?' der':'') + '" '
       + 'data-f="-1" data-c="'+c.k+'" '
       + (abre ? 'tabindex="0" onmousedown="sapClic(event,-1,\'itemcode\')" '
                 + 'ondblclick="sapClic(event,-1,\'itemcode\')" '
                 + 'title="Escribe aqui la referencia"' : '')
       + '>' + (abre ? '<span class="v nuevo">escribe una referencia\u2026</span>' : '')
       + '</td>';
  });
  h += '</tr></tbody></table>';

  box.innerHTML = h;
  sapTotales();
  if(SAP_SEL) sapMarcar(SAP_SEL.f, SAP_SEL.c);
}

function sapTotales(){
  var t = document.getElementById('sap-tot');
  if(!t) return;
  var bruto=0, desc=0, pzs=0, blt=0, peso=0, vol=0;
  (npLineas||[]).forEach(function(l){
    var cant=Number(l.quantity)||0, pre=Number(l.price)||0, d=Number(l.discount)||0;
    var b=Math.max(1,Number(l.bulto)||1);
    var inf=SAP_INFO[l.itemcode]||{};
    bruto += cant*pre;
    desc  += cant*pre*(d/100);
    pzs   += cant;
    blt   += cant/b;
    peso  += (Number(inf.peso)||0)*cant;
    vol   += (Number(inf.volumen)||0)*cant;
  });
  function fila(l, v, fuerte){
    return '<tr><td class="lbl">'+l+'</td><td class="val'
      + (fuerte?' fuerte':'') + '">'+v+'</td></tr>';
  }
  t.innerHTML = '<table class="saptot">'
    + fila('Total antes del descuento', '$ '+sapMon(bruto))
    + fila('Descuento', '$ '+sapMon(desc))
    + fila('Total', '$ '+sapMon(bruto-desc), true)
    + '</table>'
    + '<div class="sapmeta">'
      + (npLineas||[]).length + ' línea(s) · ' + pzs.toLocaleString('en-US')
      + ' pzas · ' + (Math.round(blt*100)/100) + ' bultos'
      + (peso ? (' · ' + Math.round(peso) + ' kg') : '')
      + (vol  ? (' · ' + (Math.round(vol*100)/100) + ' ft³') : '')
    + '</div>';
}

// ── Seleccion y edicion ─────────────────────────────────────────────────────
function sapCelda(f, c){
  return document.querySelector('.sapg td[data-f="'+f+'"][data-c="'+c+'"]');
}
function sapMarcar(f, c){
  var ant = document.querySelector('.sapg td.act');
  if(ant) ant.classList.remove('act');
  var td = sapCelda(f, c);
  if(td){ td.classList.add('act'); SAP_SEL = {f:f, c:c}; }
}

function sapClic(ev, f, c){
  var col = SAP_COLS.filter(function(x){ return x.k===c; })[0];
  if(!col || col.ro) return;
  if(ev.target && ev.target.className === 'tirador') return;

  // CLAVE: sin esto el cursor no aparece.
  //
  // El `mousedown` crea el campo y le da el foco, pero justo despues el
  // navegador hace lo suyo -mover el foco a la celda, que tiene tabindex, y
  // empezar a seleccionar texto- y se lo quita. El campo queda ahi, vacio de
  // foco, y parece que la celda no deja escribir.
  ev.preventDefault();

  sapMarcar(f, c);
  sapEditar(f, c);
}

function sapEditar(f, c){
  var td = sapCelda(f, c);
  if(!td || td.querySelector('input')) return;
  var col = SAP_COLS.filter(function(x){ return x.k===c; })[0];
  var l = (f>=0) ? npLineas[f] : null;
  var v = l ? sapVal(l, c, f) : '';
  if(col.mon || col.num) v = (v===''?'':String(v));

  // Se conserva el tirador: antes `innerHTML` lo borraba al entrar en la
  // celda, asi que para arrastrar habia que salir primero. Ahora esta
  // mientras se escribe.
  td.innerHTML = '<input class="ed" value="'+sapEsc(v)+'" '
    + (col.num?'inputmode="decimal" ':'') + 'autocomplete="off">'
    + '<span class="tirador" onmousedown="sapArrastrar(event,'+f+',\''+c+'\')"></span>';
  var inp = td.querySelector('input');
  // Se enfoca ya y otra vez al final del ciclo: lo primero sirve en la
  // mayoria de navegadores, lo segundo rescata los casos en que algo mas
  // reclama el foco en el mismo instante.
  inp.focus(); inp.select();
  setTimeout(function(){
    if(document.activeElement !== inp){ try{ inp.focus(); inp.select(); }catch(e){} }
  }, 0);

  // En la columna de referencia, buscador: al escribir salen las que empiezan
  // igual y, despues, las que la contienen. Nadie se sabe 141.000 codigos de
  // memoria, y obligar a teclearlo entero es la diferencia entre usar esta
  // rejilla o no usarla.
  if(c === 'itemcode') sapBuscador(inp, f);

  inp.onkeydown = function(e){
    // Con la lista abierta, las flechas y Enter la manejan a ella.
    if(SAP_LISTA && SAP_LISTA.abierta){
      if(e.key === 'ArrowDown'){ e.preventDefault(); sapListaMover(1);  return; }
      if(e.key === 'ArrowUp'){   e.preventDefault(); sapListaMover(-1); return; }
      if(e.key === 'Enter' || e.key === 'Tab'){
        if(SAP_LISTA.i >= 0){
          e.preventDefault();
          sapListaElegir();
          return;
        }
      }
      if(e.key === 'Escape'){ sapListaCerrar(); return; }
    }
    if(e.key === 'Enter'){ e.preventDefault(); sapGuardar(f,c,inp.value); sapMover(f,c,1,0); }
    else if(e.key === 'Tab'){ e.preventDefault(); sapGuardar(f,c,inp.value); sapMover(f,c,0,e.shiftKey?-1:1); }
    else if(e.key === 'Escape'){ sapRender(); }
    else if(e.key === 'ArrowDown'){ e.preventDefault(); sapGuardar(f,c,inp.value); sapMover(f,c,1,0); }
    else if(e.key === 'ArrowUp'){ e.preventDefault(); sapGuardar(f,c,inp.value); sapMover(f,c,-1,0); }
  };
  inp.onblur = function(){
    // Un poco de margen: si el blur viene de pulsar en la lista, hay que
    // dejar que el clic llegue antes de guardar y repintar.
    setTimeout(function(){
      if(SAP_LISTA && SAP_LISTA.eligiendo) return;
      sapListaCerrar();
      sapGuardar(f, c, inp.value);
    }, 140);
  };
  inp.onpaste = function(e){ sapPegar(e, f, c); };
}

/* ── Buscador de referencias ──────────────────────────────────────────────
   Dos pasadas en la misma consulta: primero las que EMPIEZAN por lo escrito
   y luego las que lo contienen, en el codigo o en la descripcion. Asi quien
   sabe el principio del codigo lo encuentra arriba, y quien solo recuerda
   "rallador" tambien llega. */
var SAP_LISTA = null, SAP_BUSCA_T = null;

function sapBuscador(inp, f){
  inp.oninput = function(){
    var txt = inp.value.trim();
    clearTimeout(SAP_BUSCA_T);
    if(txt.length < 2){ sapListaCerrar(); return; }
    // Se espera a que deje de teclear: una consulta por letra sobra.
    SAP_BUSCA_T = setTimeout(function(){ sapBuscarRef(txt, inp, f); }, 220);
  };
}

var SAP_CAMPOS = 'itemcode,itemname,precioventa,unidadesbulto,onhand,foto_url';

async function sapBuscarRef(txt, inp, f){
  var t = encodeURIComponent(txt);
  var res = [];
  try{
    // Las que EMPIEZAN igual van primero: quien sabe el principio del codigo
    // lo quiere arriba y no mezclado entre cien coincidencias.
    var a = await q('vista_inventario',
      'select=' + SAP_CAMPOS + '&itemcode=ilike.' + t + '*&order=itemcode&limit=40') || [];
    res = a.slice();
    // Y despues las que lo contienen, en el codigo o en la descripcion.
    var b = await q('vista_inventario',
      'select=' + SAP_CAMPOS
      + '&or=(itemcode.ilike.*' + t + '*,itemname.ilike.*' + t + '*)'
      + '&order=itemcode&limit=' + Math.max(0, 120 - res.length)) || [];
    var ya = {};
    res.forEach(function(x){ ya[x.itemcode] = 1; });
    b.forEach(function(x){ if(!ya[x.itemcode]) res.push(x); });
  }catch(e){ return; }
  if(!res.length){ sapListaCerrar(); return; }
  sapListaAbrir(res, inp, f, txt);
}

function sapListaAbrir(res, inp, f, txt){
  sapListaCerrar();
  var td = inp.closest('td');
  if(!td) return;
  var r = td.getBoundingClientRect();
  var d = document.createElement('div');
  d.className = 'saplista';
  d.style.left = Math.min(r.left, window.innerWidth - 560) + 'px';
  d.style.top  = (r.bottom + 1) + 'px';

  // Un campo propio para afinar sin salir de la lista. Con cien coincidencias,
  // obligar a volver a la celda y reescribir es lo que hace que nadie la use.
  d.innerHTML = '<div class="cab">'
    + '<input class="filtro" placeholder="Afinar la b\u00fasqueda\u2026" '
    + 'value="' + sapEsc(txt||'') + '">'
    + '<span class="n"></span></div>'
    + '<div class="cuerpo"></div>';
  document.body.appendChild(d);

  SAP_LISTA = {el:d, todas:res, res:res, i:0, abierta:true,
               inp:inp, f:f, eligiendo:false};
  sapListaFiltrar('');

  var filtro = d.querySelector('.filtro');
  filtro.onmousedown = function(e){ e.stopPropagation(); SAP_LISTA.eligiendo = true; };
  filtro.onclick = function(){ SAP_LISTA.eligiendo = false; };
  filtro.oninput = function(){ sapListaFiltrar(filtro.value); };
  filtro.onkeydown = function(e){
    if(e.key === 'ArrowDown'){ e.preventDefault(); sapListaMover(1); }
    else if(e.key === 'ArrowUp'){ e.preventDefault(); sapListaMover(-1); }
    else if(e.key === 'Enter'){ e.preventDefault(); sapListaElegir(); }
    else if(e.key === 'Escape'){ sapListaCerrar(); inp.focus(); }
  };
}

// Filtra sobre lo ya traido, sin volver a consultar.
function sapListaFiltrar(txt){
  if(!SAP_LISTA) return;
  var t = String(txt||'').trim().toUpperCase();
  SAP_LISTA.res = !t ? SAP_LISTA.todas : SAP_LISTA.todas.filter(function(x){
    return String(x.itemcode).toUpperCase().indexOf(t) >= 0
        || String(x.itemname||'').toUpperCase().indexOf(t) >= 0;
  });
  SAP_LISTA.i = 0;

  var cuerpo = SAP_LISTA.el.querySelector('.cuerpo');
  var n = SAP_LISTA.el.querySelector('.n');
  if(n) n.textContent = SAP_LISTA.res.length
    + (SAP_LISTA.res.length === 1 ? ' art\u00edculo' : ' art\u00edculos');

  if(!SAP_LISTA.res.length){
    cuerpo.innerHTML = '<div class="vacio">Ninguno coincide.</div>';
    return;
  }
  cuerpo.innerHTML = SAP_LISTA.res.map(function(x, i){
    var disp = Number(x.onhand)||0;
    var b = Math.max(1, Number(x.unidadesbulto)||1);
    return '<div class="it" data-i="'+i+'">'
      + (x.foto_url
          ? ('<img src="' + sapEsc(x.foto_url) + '" alt="" loading="lazy">')
          : '<span class="sinfoto"></span>')
      + '<span class="cod">' + sapEsc(x.itemcode) + '</span>'
      + '<span class="nom">' + sapEsc(String(x.itemname||'')) + '</span>'
      + '<span class="pre">' + sapMon(x.precioventa) + '</span>'
      + '<span class="stk">' + disp.toLocaleString('en-US')
        + (b > 1 ? ('<i>/' + b + '</i>') : '') + '</span>'
      + '</div>';
  }).join('');

  Array.prototype.forEach.call(cuerpo.querySelectorAll('.it'), function(el){
    el.onmousedown = function(){ SAP_LISTA.eligiendo = true; };
    el.onclick = function(){
      SAP_LISTA.i = parseInt(el.getAttribute('data-i'), 10);
      sapListaElegir();
    };
  });
  sapListaPintar();
}

function sapListaPintar(){
  if(!SAP_LISTA) return;
  Array.prototype.forEach.call(SAP_LISTA.el.querySelectorAll('.it'), function(el, i){
    el.classList.toggle('sel', i === SAP_LISTA.i);
  });
}

function sapListaMover(d){
  if(!SAP_LISTA) return;
  SAP_LISTA.i = Math.max(0, Math.min(SAP_LISTA.res.length-1, SAP_LISTA.i + d));
  sapListaPintar();
  var el = SAP_LISTA.el.querySelectorAll('.it')[SAP_LISTA.i];
  if(el && el.scrollIntoView) el.scrollIntoView({block:'nearest'});
}

function sapListaElegir(){
  if(!SAP_LISTA || SAP_LISTA.i < 0) return;
  var x = SAP_LISTA.res[SAP_LISTA.i];
  var f = SAP_LISTA.f;
  sapListaCerrar();
  if(!x) return;
  if(f === -1) sapAgregar([x.itemcode]);
  else sapCambiarItem(f, x.itemcode, true);
}

function sapListaCerrar(){
  if(SAP_LISTA && SAP_LISTA.el){
    try{ SAP_LISTA.el.remove(); }catch(e){}
  }
  SAP_LISTA = null;
}

function sapMover(f, c, df, dc){
  var cols = sapColsVisibles().filter(function(x){ return !x.ro; });
  var ci = cols.map(function(x){ return x.k; }).indexOf(c);
  if(dc){
    ci += dc;
    if(ci < 0){ ci = cols.length-1; f--; }
    if(ci >= cols.length){ ci = 0; f++; }
  }
  f += df;
  var max = (npLineas||[]).length;
  if(f > max) f = max;
  if(f < 0) f = 0;
  var destino = (f >= max) ? -1 : f;
  setTimeout(function(){
    sapMarcar(destino, cols[Math.max(0,Math.min(ci,cols.length-1))].k);
    sapEditar(destino, cols[Math.max(0,Math.min(ci,cols.length-1))].k);
  }, 10);
}

async function sapGuardar(f, c, valor){
  valor = String(valor==null?'':valor).trim();
  if(f === -1){
    // Fila nueva: solo tiene sentido empezar por la referencia.
    if(c !== 'itemcode' || !valor) { sapRender(); return; }
    await sapAgregar([valor]);
    return;
  }
  var l = npLineas[f];
  if(!l) return;
  if(c === 'itemcode'){
    if(!valor){ npLineas.splice(f,1); sapRender(); sapSincronizar(); return; }
    if(valor !== l.itemcode){ await sapCambiarItem(f, valor); return; }
  }
  else if(c === 'quantity') l.quantity = Math.max(0, sapNum(valor));
  else if(c === 'bultos'){
    var b = Math.max(1, Number(l.bulto)||1);
    l.quantity = Math.max(0, Math.round(sapNum(valor) * b));
  }
  else if(c === 'price')    l.price    = Math.max(0, sapNum(valor));
  else if(c === 'discount') l.discount = Math.min(100, Math.max(0, sapNum(valor)));
  sapRender();
  sapSincronizar();
}

// ── Pegar desde Excel ───────────────────────────────────────────────────────
// Excel pone en el portapapeles filas separadas por salto de linea y columnas
// por tabulador. Se reparte desde la celda activa hacia abajo y a la derecha,
// respetando que columnas son editables.
async function sapPegar(ev, f, c){
  var txt = (ev.clipboardData || window.clipboardData).getData('text');
  if(!txt || txt.indexOf('\t') < 0 && txt.indexOf('\n') < 0) return;  // un solo valor: pegado normal
  ev.preventDefault();

  var filas = txt.replace(/\r/g,'').split('\n').filter(function(x){ return x.trim()!==''; });
  var cols = sapColsVisibles().filter(function(x){ return !x.ro; });
  var ci = cols.map(function(x){ return x.k; }).indexOf(c);
  if(ci < 0) ci = 0;

  // Si se pega sobre la columna de referencia, cada fila puede traer el
  // articulo y sus datos: se crean las lineas que falten.
  var nuevas = [];
  for(var r=0; r<filas.length; r++){
    var celdas = filas[r].split('\t');
    var fi = (f === -1) ? (npLineas.length + nuevas.length) : (f + r);

    if(cols[ci].k === 'itemcode'){
      var cod = String(celdas[0]||'').trim();
      if(!cod) continue;
      if(fi >= npLineas.length){ nuevas.push({cod:cod, celdas:celdas}); continue; }
      await sapCambiarItem(fi, cod, true);
    }
    // El resto de columnas de esa fila
    for(var k=0; k<celdas.length; k++){
      var col = cols[ci + k];
      if(!col || col.k === 'itemcode') continue;
      var linea = npLineas[fi];
      if(!linea) continue;
      sapAplicar(linea, col.k, celdas[k]);
    }
  }

  if(nuevas.length){
    await sapAgregar(nuevas.map(function(x){ return x.cod; }));
    // Y despues sus valores, ya con la linea creada.
    nuevas.forEach(function(x){
      var linea = npLineas.filter(function(l){
        return String(l.itemcode).toUpperCase() === x.cod.toUpperCase(); })[0];
      if(!linea) return;
      for(var k=1; k<x.celdas.length; k++){
        var col = cols[ci + k];
        if(col && col.k !== 'itemcode') sapAplicar(linea, col.k, x.celdas[k]);
      }
    });
  }
  sapRender();
  sapSincronizar();
}

function sapAplicar(l, k, valor){
  valor = String(valor==null?'':valor).trim();
  if(valor === '') return;
  if(k === 'quantity') l.quantity = Math.max(0, sapNum(valor));
  else if(k === 'bultos'){
    var b = Math.max(1, Number(l.bulto)||1);
    l.quantity = Math.max(0, Math.round(sapNum(valor)*b));
  }
  else if(k === 'price')    l.price    = Math.max(0, sapNum(valor));
  else if(k === 'discount') l.discount = Math.min(100, Math.max(0, sapNum(valor)));
}

// ── Arrastrar para repetir ──────────────────────────────────────────────────
// El cuadradito de la esquina, como en Excel: se arrastra hacia abajo y el
// valor se repite en las filas que se recorren.
function sapArrastrar(ev, f, c){
  ev.preventDefault();
  ev.stopPropagation();
  if(f < 0) return;
  var l = npLineas[f];
  if(!l) return;
  var valor = sapVal(l, c, f);
  var hasta = f;

  function sobre(e){
    var td = document.elementFromPoint(e.clientX, e.clientY);
    while(td && td.tagName !== 'TD') td = td.parentElement;
    if(!td) return;
    var nf = parseInt(td.getAttribute('data-f'), 10);
    if(isNaN(nf) || nf < 0) return;
    hasta = nf;
    // Marca visual de hasta donde va a llegar.
    Array.prototype.forEach.call(document.querySelectorAll('.sapg td[data-c="'+c+'"]'),
      function(x){
        var xf = parseInt(x.getAttribute('data-f'),10);
        x.classList.toggle('relleno', xf>=Math.min(f,hasta) && xf<=Math.max(f,hasta));
      });
  }
  function soltar(){
    document.removeEventListener('mousemove', sobre);
    document.removeEventListener('mouseup', soltar);
    var a = Math.min(f, hasta), b = Math.max(f, hasta);
    for(var i=a; i<=b; i++){
      if(i===f || !npLineas[i]) continue;
      sapAplicar(npLineas[i], c, valor);
    }
    sapRender();
    sapSincronizar();
  }
  document.addEventListener('mousemove', sobre);
  document.addEventListener('mouseup', soltar);
}

// ── Articulos ───────────────────────────────────────────────────────────────
async function sapBuscar(codes){
  var out = {};
  codes = (codes||[]).filter(Boolean);
  if(!codes.length) return out;
  try{
    for(var i=0;i<codes.length;i+=150){
      var lote = codes.slice(i,i+150)
        .map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      var r = await q('vista_inventario',
        'select=itemcode,itemname,precioventa,unidadesbulto,onhand,disponiblebodega,'
        + 'peso,volumen,codebars&itemcode=in.('+lote+')&limit='+lote.split(',').length) || [];
      r.forEach(function(x){ out[String(x.itemcode).toUpperCase()] = x; });
    }
  }catch(e){}
  return out;
}

async function sapAgregar(codes){
  var info = await sapBuscar(codes);
  // Lo separado en pedidos autorizados, para el disponible real.
  try{ if(typeof sepCargar === 'function') await sepCargar(codes); }catch(e){}

  var noHay = [];
  codes.forEach(function(cod){
    var x = info[String(cod).toUpperCase()];
    if(!x){ noHay.push(cod); return; }
    var b = Math.max(1, Number(x.unidadesbulto)||1);
    sapGuardarInfo(x);
    var ya = npLineas.filter(function(l){
      return String(l.itemcode).toUpperCase() === String(x.itemcode).toUpperCase(); })[0];
    if(ya){ ya.quantity = (Number(ya.quantity)||0) + b; return; }
    npLineas.push({
      itemcode: x.itemcode,
      itemname: x.itemname || x.itemcode,
      quantity: b,                       // un bulto, que es como se vende
      price: Number(x.precioventa)||0,
      discount: 0,
      bulto: b
    });
  });
  sapRender();
  sapSincronizar();
  if(noHay.length){
    alert('No encontré en el catálogo:\n' + noHay.slice(0,12).join(', ')
      + (noHay.length>12 ? ('\ny ' + (noHay.length-12) + ' más.') : ''));
  }
}

async function sapCambiarItem(f, cod, silencioso){
  var info = await sapBuscar([cod]);
  var x = info[String(cod).toUpperCase()];
  if(!x){
    if(!silencioso) alert('No encontré el artículo ' + cod + '.');
    sapRender();
    return;
  }
  try{ if(typeof sepCargar === 'function') await sepCargar([x.itemcode]); }catch(e){}
  sapGuardarInfo(x);
  var b = Math.max(1, Number(x.unidadesbulto)||1);
  var l = npLineas[f];
  l.itemcode = x.itemcode;
  l.itemname = x.itemname || x.itemcode;
  l.bulto = b;
  if(!l.quantity) l.quantity = b;
  if(!l.price) l.price = Number(x.precioventa)||0;
  sapRender();
  sapSincronizar();
}

function sapGuardarInfo(x){
  var onhand = Number(x.onhand != null ? x.onhand : x.disponiblebodega) || 0;
  var aut = 0;
  try{ if(typeof sepAutorizado === 'function') aut = sepAutorizado(x.itemcode)||0; }catch(e){}
  SAP_INFO[x.itemcode] = {
    codebars: x.codebars || '',
    onhand: onhand,
    comprometido: aut,
    disponible: onhand - aut,
    peso: Number(x.peso)||0,
    volumen: Number(x.volumen)||0
  };
}

function sapQuitar(f){
  if(f<0 || !npLineas[f]) return;
  npLineas.splice(f,1);
  sapRender();
  sapSincronizar();
}

// Lo que ve el resto del portal. El modo SAP no guarda nada por su cuenta:
// escribe en `npLineas` y avisa, para que el carrito y los totales de siempre
// se enteren.
// Guarda el borrador. El modo SAP escribe en `npLineas`, que es el mismo
// carrito, pero hay que avisar para que se guarde y para que los botones de
// continuar se enteren de que ya hay lineas.
function sapGuardarBorrador(){
  // El portal guarda el borrador con distintos nombres segun la version; se
  // usa el que exista en vez de dar uno por supuesto.
  var f = ['bdGuardar','bdAuto','bdSave','bdGuardarAuto']
    .map(function(n){ return window[n]; })
    .filter(function(x){ return typeof x === 'function'; })[0];
  if(f){ try{ f(); }catch(e){} }
}

function sapSincronizar(){
  try{ if(typeof cotizUpdate === 'function') cotizUpdate(); }catch(e){}
  try{ if(typeof npRenderLineas === 'function') npRenderLineas(); }catch(e){}
  try{ if(typeof npUpdateBtn === 'function') npUpdateBtn(); }catch(e){}
  sapGuardarBorrador();

  // Y el boton de continuar de la barra fija.
  var seguir = document.getElementById('np-btn3-sap');
  if(seguir){
    var n = (npLineas||[]).length;
    seguir.disabled = !n;
    seguir.textContent = n ? ('Ver pedido (' + n + ') \u2192') : 'Ver pedido \u2192';
  }
}

// ── Entrar y salir ──────────────────────────────────────────────────────────
async function sapModo(){
  SAP_ON = !SAP_ON;
  var box = document.getElementById('sap-box');
  var normal = document.getElementById('np-prod-normal');
  if(!box) return;
  box.style.display = SAP_ON ? 'block' : 'none';
  if(normal) normal.style.display = SAP_ON ? 'none' : '';
  var btn = document.getElementById('np-btn-sap');
  if(btn) btn.textContent = SAP_ON ? 'Volver al catálogo' : 'Modo SAP';
  // El boton de continuar vive en la barra fija: los de la vista normal
  // estan dentro de la tarjeta que se oculta, asi que en modo SAP no habria
  // forma de avanzar al pedido.
  var seguir = document.getElementById('np-btn3-sap');
  if(seguir) seguir.style.display = SAP_ON ? '' : 'none';

  var pista = document.getElementById('np-sap-pista');
  if(pista) pista.textContent = SAP_ON
    ? 'Escribe la referencia y tabula. Lo que pongas aquí va al mismo pedido.'
    : 'Para meter muchas líneas de golpe o pegar desde Excel.';
  var cab = document.getElementById('sap-cli');
  if(cab) cab.textContent = (typeof npCli!=='undefined' && npCli)
    ? ('  ' + (npCli.cardcode||'') + '  ' + (npCli.cardname||'')) : '';
  if(!SAP_ON){ sapSincronizar(); return; }

  // Al entrar se completan los datos de lo que ya hay en el carrito.
  var codes = (npLineas||[]).map(function(l){ return l.itemcode; });
  if(codes.length){
    var info = await sapBuscar(codes);
    try{ if(typeof sepCargar === 'function') await sepCargar(codes); }catch(e){}
    Object.keys(info).forEach(function(k){ sapGuardarInfo(info[k]); });
  }
  sapRender();
}
